const map = {
	"./ALIOR-circle.png": 56565,
	"./CITI-circle.png": 52347,
	"./MBANK-circle.png": 14549,
	"./MILLENNIUM-circle.png": 70606,
	"./NEST-circle.png": 51502,
	"./PEKAO_BH-circle.png": 25671,
	"./PKO_BP-circle.png": 13397,
	"./SANTANDER-circle.png": 8496,
	"./VELO-circle.png": 35416
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19577;